import React, { useContext, useEffect, useState } from "react";
import Collapse from "rc-collapse";
import "rc-collapse/assets/index.css";
import { ISidebarComponentProps } from "./ITopBarComponentsProps";
import { Map } from "immutable";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import ContentLoader from "react-content-loader";
import "./SidebarComponent.scss";
import "./sidebar-responsive.scss";
import { PlusWithCircle, SearchIcon } from "../../constants/icons";
import HomeIcon from './newIcons/Home';
import LibraryIcon from './newIcons/Library';
import CourseIcon from './newIcons/Course';
import CalenderIcon from './newIcons/Calender';
import PeopleIcon from './newIcons/People';
import { push } from "connected-react-router";
import miscUtils from "../../utils/miscUtils";
import { Link } from "react-router-dom";
import { globalActions } from "../../store/actions";
import "../../assets/styles/abstracts/_colors.scss";
import { GroupService } from "api/services/groups";
import ShareGroup from "components/shareGroup";
import store from "../../store/configureStore";
import { toast } from "react-toastify";
import AppModal from "elements/modal/appModal";
import { Emoji } from "emoji-mart";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { getChannelCollections, getUnAssignedChannels } from "./domain";
import { ChannelService } from "api/services/channels";
import ChannelHashTag from "./newIcons/ChannelHashTag";
import { useHistory } from 'react-router';
import { getlocalStorageValue } from "utils/localStorage";
import InvitePlusIcon from "./newIcons/InvitePlusIcon";
import ReactModal from "react-modal";
import GlobeIcon from './newIcons/Globe';
import { AppContext } from "containers/main/MainComponent";
import FeedIcon from 'components/sidebar/newIcons/Feed';
import { AccessLevels } from "containers/channels/channelDetails/domain";
import { showchannelSidebarAtomOnMobile } from "showMessageMenuAtom";
import { useAtom } from "jotai";

const SidebarComponent: React.FC<ISidebarComponentProps> = (props: any) => {

  const appContext = useContext(AppContext);
  
  const { groupChannels, setGroupChannels } = useContext(AppContext);
  const history = useHistory();
  const {
    closeHamburgerMenu,
    subdomain,
    groups: { userGroups, loadSidebarGroup, postData },
    // @ts-ignore
    global: { currentView, goToSidebarChannel, refreshSidebar, theme },
    setChannelSidebarStatus,
    group,
    // memberCommunityUnreadCount
  } = props;

  const [isSideBar, setIsSideBar] = useState<any>("");
  const [areGroupsEmpty, checkGroups] = useState<boolean>();
  const [showChannelSidebar, ] = useAtom(showchannelSidebarAtomOnMobile) as any;
  const [groupChannelsLoading, setGroupChannelsLoading] = useState<boolean>(
    false
  );
  const [selectedChannel, selectChannel] = useState<number>(-1);
  const [selectedGroup, selectGroup] = useState<any>(-1);
  const [, setIsAdmin] = useState<boolean>(false);
  const [postsSearchQuery, setPostsSearchQuery] = useState<string>("");
  const [loaded, setLoaded] = useState<any>(null);
  const [isGroup, setIsGroup] = useState<boolean>(false);
  const [sidebarGroups, setSidebarGroups] = useState<any>();
  const [chosenChannel, setChosenChannel] = useState<any>();
  const [isModalOpen, setToggleModal] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false) //used for inactive subscription pop up
  const [channelCollections, setChannelCollections] = useState<Array<any>>([]);
  const [unAssignedChannels, setUnAssignedChannels] = useState<Array<any>>([]);
  const [unAssignedChannelsActive, setUnAssignedChannelsActive] = useState<boolean>(true);
  const [linksActive, setlinksActive] = useState<boolean>(true);
  const [shouldShowHomePage, setShouldShowHomePage] = useState<boolean>(false);
  const [reloadKey, setReloadKey] = useState<number>(0);

  useEffect(() => {
    if(
      (
        !shouldShowMenuText &&
        groupChannels &&
        groupChannels.data &&
        groupChannels.data.length === 0 &&
        !(group && group.external_links && group.external_links && group.external_links.length)
      ) ||
      window.location.pathname.split("/")[1] === "about-preview"
    ) {
      appContext.isSidebarEmptyRef.current = true;
    }

    if(
      appContext.isSidebarEmptyRef.current &&
      (
        (
          shouldShowMenuText ||
          (
            groupChannels.data &&
            groupChannels.data.length
          )
        ) && window.location.pathname.split("/")[1] !== "about-preview"
      )
    ) {
      appContext.isSidebarEmptyRef.current = false;
    }
  });

  useEffect(() => {
    if (
      props.group &&
      props.group.home_page_config &&
      props.group.home_page_config.status &&
      (
        showAnnouncementHomeSection() ||
        showNewMemberHomeSection() ||
        showUpcomingEventsHomeSection() ||
        showSuggestedContentHomeSection() ||
        showUserCoursesHomeSection()
        // showHomeFeed()
      )
    ) {
      setShouldShowHomePage(true);
    }
  }, [props.group, props.customizedPostsData, props.homePageConfigDetails, props.userCourses]);

  useEffect(() => {
    setReloadKey((prev: number) => prev + 1);
    if (groupChannels && groupChannels.length > 0) {
      // if (channelCollections.length === 0) {
        setChannelCollections(getChannelCollections(groupChannels));
      // }
      // if (unAssignedChannels.length === 0) {
        setUnAssignedChannels(getUnAssignedChannels(groupChannels));
      // }
    }
  }, [groupChannels]);

  // useEffect(() => {
  //   if (groupChannels && groupChannels.length > 0) {
  //     // setTimeout(() => {
  //     setChannelCollections(getChannelCollections(groupChannels));
  //     setUnAssignedChannels(getUnAssignedChannels(groupChannels));
  //     // }, 500)
  //   }
  // }, [window.location.pathname, groupChannels, group])

  useEffect(() => {
    setIsSideBar(getlocalStorageValue("sidebar") && getlocalStorageValue("sidebar").value);
  }, []);

  function lockBackground() {
    if (isModalOpen) {
      document.body.classList.add("stop-scrolling");
    }
  }

  useEffect(() => {
    if (props.location.pathname) {
      unlockBackground();
    }
  }, [props.location.pathname]);

  useEffect(() => {
    if(
      (
        !shouldShowMenuText &&
        groupChannels &&
        groupChannels.length === 0 &&
        !(group && group.external_links && group.external_links && group.external_links.length)
      ) ||
      window.location.pathname.split("/")[1] === "about-preview"
    ) {
      appContext.isSidebarEmptyRef.current = true;
    }

    if(
      appContext.isSidebarEmptyRef.current &&
      (
        (
          shouldShowMenuText ||
          (
            groupChannels &&
            groupChannels.length
          )
        ) && window.location.pathname.split("/")[1] !== "about-preview"
      )
    ) {
      appContext.isSidebarEmptyRef.current = false;
    }
  });

  function fetchChannels(groupDataID: number) {
    if (window.location.pathname.split("/")[1] === 'settings') return
    ChannelService.getInstance()
      .getGroupChannels(groupDataID)
      .then((channels: any) => {
        setGroupChannels(channels.data);

      }).catch((error: any) => {
        console.error(error)
        new Error(error)
      })

  }

  useEffect(() => {
    if (props.global.selectedGroup) {
      fetchChannels(props.global.selectedGroup.id);
    }
  }, [
    props.global.selectedGroup && props.global.selectedGroup.id,
    // group && group.user_membership
  ]);

  useEffect(() => {
    lockBackground();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen]);

  useEffect(() => {
    if(
      (
        !shouldShowMenuText &&
        groupChannels &&
        groupChannels.length === 0 &&
        !(group && group.external_links && group.external_links && group.external_links.length)
      ) ||
      window.location.pathname.split("/")[1] === "about-preview"
    ) {
      appContext.isSidebarEmptyRef.current = true;
    }

    if(
      appContext.isSidebarEmptyRef.current &&
      (
        (
          shouldShowMenuText ||
          (
            groupChannels &&
            groupChannels.length
          )
        ) && window.location.pathname.split("/")[1] !== "about-preview"
      )
    ) {
      appContext.isSidebarEmptyRef.current = false;
    }
  });

  const showAnnouncementHomeSection = () => {
    return (
      props.group.home_page_config &&
      props.group.home_page_config.status &&
      props.group.home_page_config.announcement &&
      props.homePageConfigDetails &&
      props.homePageConfigDetails.announcement
    )
  }

  const showNewMemberHomeSection = () => {
    return (
      props.group.home_page_config &&
      props.group.home_page_config.status &&
      props.group.home_page_config.new_members &&
      props.homePageConfigDetails &&
      props.homePageConfigDetails.new_members &&
      props.homePageConfigDetails.new_members.filter((member: any) => !!member).length > 0
    )
  }

  const showSuggestedContentHomeSection = () => {
    return (
      props.group.home_page_config &&
      props.group.home_page_config.status &&
      props.group.home_page_config.library_contents &&
      props.homePageConfigDetails &&
      props.homePageConfigDetails.library_contents &&
      props.homePageConfigDetails.library_contents.filter((content: any) => content.contentable).length > 0
    )
  }

  const showUpcomingEventsHomeSection = () => {
    return (
      props.group.home_page_config &&
      props.group.home_page_config.status &&
      props.group.home_page_config.upcoming_events &&
      props.homePageConfigDetails &&
      props.homePageConfigDetails.upcoming_events &&
      props.homePageConfigDetails.upcoming_events.filter((event: any) => !!event).length > 0
    )
  }

  const showUserCoursesHomeSection = () => {
    return (
      props.userCourses &&
      props.userCourses.data &&
      props.userCourses.data.length
    )
  }

  useEffect(() => {
    if(
      (
        !shouldShowMenuText &&
        groupChannels &&
        groupChannels.length === 0 &&
        !(group && group.external_links && group.external_links && group.external_links.length)
      ) ||
      window.location.pathname.split("/")[1] === "about-preview"
    ) {
      appContext.isSidebarEmptyRef.current = true;
    }

    if(
      appContext.isSidebarEmptyRef.current &&
      (
        (
          shouldShowMenuText ||
          (
            groupChannels &&
            groupChannels.length
          )
        ) && window.location.pathname.split("/")[1] !== "about-preview"
      )
    ) {
      appContext.isSidebarEmptyRef.current = false;
    }
  });

  useEffect(() => {
    if(
      (
        !shouldShowMenuText &&
        groupChannels &&
        groupChannels.length === 0 &&
        !(group && group.external_links && group.external_links && group.external_links.length)
      ) ||
      window.location.pathname.split("/")[1] === "about-preview"
    ) {
      appContext.isSidebarEmptyRef.current = true;
    }

    if(
      appContext.isSidebarEmptyRef.current &&
      (
        (
          shouldShowMenuText ||
          (
            groupChannels &&
            groupChannels.length
          )
        ) && window.location.pathname.split("/")[1] !== "about-preview"
      )
    ) {
      appContext.isSidebarEmptyRef.current = false;
    }
  });

  function unlockBackground() {
    document.body.classList.remove("stop-scrolling");
  }

  function checkingGroups() {
    if (userGroups) {
      if (
        Object.keys(userGroups.data).length === 0 &&
        userGroups.data.constructor === Object
      ) {
        setTimeout(() => {
          checkGroups(true);
        }, 1000);
      }
      if (userGroups.data === undefined || userGroups.data.length === 0) {
        setTimeout(() => {
          checkGroups(true);
        }, 1000);
      }
    }
  }

  useEffect(() => {
    if (userGroups) {
      checkingGroups();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userGroups]);

  useEffect(() => {
    if (
      userGroups &&
      (!sidebarGroups ||
        (sidebarGroups && sidebarGroups.data.length < userGroups.data.length))
    ) {
      setSidebarGroups(userGroups);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userGroups, JSON.stringify(userGroups)]);

  useEffect(() => {
    if (userGroups) {
      setSidebarGroups(userGroups);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(userGroups)]);

  useEffect(() => {
    if (!postsSearchQuery.length) {
      props.setPostsQuery(postsSearchQuery);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postsSearchQuery]);

  useEffect(() => {
    if (group) {
      store.store.dispatch(globalActions.setSelectedGroup(group));
    }
    if (props.location.pathname) {
      const groupData: any = miscUtils.getGroupSlugChannel(props.location.pathname);
      setIsGroup(subdomain || groupData.slug.length > 0);
      switchToGroup();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.location.pathname,
    subdomain,
    goToSidebarChannel,
    refreshSidebar,
    group
  ]);

  useEffect(() => {
    checkSelectedGroupPermission();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sidebarGroups, selectedGroup, selectedChannel]);

  useEffect(() => {
    checkPostPage(
      postData && postData.channel_id,
      postData && postData.group.slug
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postData, group]);

  const shouldShowMenuText = (
    (group && group.menu['feed']['show']) ||
    (group && group.menu['courses']['show']) ||
    (group && group.menu['library']['show'] ) ||
    (group && group.menu['events']['show'] ) ||
    (group && group.menu['people']['show'] && group.user_membership && miscUtils.isActiveCommunityMember(group.user_membership)) ||
    group && group.menu['invite']['show'] ||
    shouldShowHomePage
  )

  // const showingCommuintyLandingPage = () => {
  //   return (
  //     ((
  //       (props.group && props.group.user_membership === null) ||
  //       miscUtils.isMembershipPendingApproval(props.group && props.group.user_membership)
  //     ) || (!props.uid))
  //   )
  // }

  const showCommunityLandingPage = () => {
    return (
      ((
        (props.group && props.group.user_membership === null) ||
        miscUtils.isMembershipPendingApproval(props.group && props.group.user_membership)
      ) || (!props.uid)) &&
      window.location.pathname === "/"
    )
  }

  function switchToGroup() {
    if (groupChannelsLoading) {
      return;
    }
    if (group && group.id && !loaded) {
      setGroupChannelsLoading(true);
      setLoaded("loaded");
      if (props.group && props.group.channels) {
        selectGroup(group.slug);
        if (chosenChannel) {
          selectChannel(chosenChannel);
        }
        if (props.location.pathname.split("/").includes("channel")) {
          setPostsSearchQuery("");
          const params = props.location.pathname.split("/");
          selectChannel(params.pop());
        } else if (props.location.pathname.split("/").includes("posts")) {
          selectChannel(props.currentChannel);
        } else {
          selectChannel(group.default_channel.slug);
        }
        setGroupChannelsLoading(false);
      } else {
        const channels: any = [];
        channels.push(group.default_channel);
        selectGroup(group.slug);
        selectChannel(group.default_channel.slug);
        setGroupChannelsLoading(false);
      }

    }
    // validate active channels on load
    const params = props.location.pathname.split("/").pop();
    const INVALID_ACTIVE_CHANEL = selectedChannel !== parseInt(params);
    // force active channel reset on home route
    if (group && props.location.pathname === "/home" && !shouldShowHomePage && !showCommunityLandingPage()) {
      selectChannel(group.default_channel.slug);
    }
    else if (group && INVALID_ACTIVE_CHANEL) { // validate active channels against route chanel id
      selectChannel(params)
    }
  }

  function viewChannel(channelId: number) {
    if (window.innerWidth < 992) {
      closeHamburgerMenu();
    }

    setChosenChannel(channelId);
    selectChannel(channelId);
    props.goToChannel(selectedGroup, channelId, subdomain);
  }

  const userPlanIsInAuthorizedPlans = (channelData: any): boolean => {
    if (
      !props.group.user_membership ||
      !props.group.user_membership.active_subscription
    ) {
      return false;
    }
    let planIsAuthorized: boolean = false;
    channelData.authorized_plans.forEach((plan: any) => {
      if (plan.id === props.group.user_membership.active_subscription.plan.id) {
        planIsAuthorized = true;
      }
    })
    return planIsAuthorized;
  }
  const redirectToLink = (channelData: any) => {
    const FREE_PLAN_PRICE: number = 0;


    if (
      props.group &&
      channelData &&
      channelData.lock_screen_active &&
      channelData.lock_screen_type === 'redirect'
    ) {

      // channel is by plan
      if (
        props.group.user_membership &&
        !miscUtils.isAdmin(props.group.user_membership) &&
        channelData.status === AccessLevels.Plan &&
        !userPlanIsInAuthorizedPlans(channelData) &&
        !miscUtils.isChannelMember(props.group.user_membership, channelData)
      ) {
        return channelData.lock_screen_default_url
      }

      // channel is by segment
      if (
        props.group.user_membership &&
        !miscUtils.isAdmin(props.group.user_membership) &&
        (channelData.status === AccessLevels.Segment) &&
        channelData.authorized_segments &&
        !miscUtils.userIsOnResourseSegment(props.group.user_membership, channelData.authorized_segments) &&
        !miscUtils.isChannelMember(props.group.user_membership, channelData)
      ) {
        return channelData.lock_screen_default_url

      }

      // channel is private
      if (
        (channelData.status === AccessLevels.Private) &&
        !miscUtils.isAdmin(props.group.user_membership) &&
        !miscUtils.isChannelMember(props.group.user_membership, channelData)
      ) {
        return channelData.lock_screen_default_url

      }

      // channel by paid members
      if (
        (channelData.status === AccessLevels.Paid) &&
        !miscUtils.isAdmin(props.group.user_membership) &&
        !miscUtils.isChannelMember(props.group.user_membership, channelData) &&
        miscUtils.isActiveCommunityMember(props.group && props.group.user_membership) &&
        props.group.user_membership &&
        props.group.user_membership.active_subscription &&
        props.group.user_membership.active_subscription.plan.price === FREE_PLAN_PRICE
      ) {
        return channelData.lock_screen_default_url

      }

      // logged out user
      if (!props.uid) {
        return channelData.lock_screen_default_url

      }

    }
    else {
      return null
    }
  }

  function getPeopleLinkStyle() {
    if (theme && theme.custom && theme.custom.primaryColor && theme.custom.primaryColor !== '#ffffff' && window.location.pathname.split("/").includes("members")) {
      // const rgbCommunityColor: any = miscUtils.hexToRgb(theme.custom.primaryColor);

      return {
        color: theme.custom.fontColor,
        backgroundColor: theme.custom.primaryColor

        // backgroundColor: rgbCommunityColor ? `rgba(${rgbCommunityColor.r}, ${rgbCommunityColor.g}, ${rgbCommunityColor.b}, .1)` : '',
      }
    }
    return {}
  }

  function getEventsLinkStyle() {
    if (theme && theme.custom && theme.custom.primaryColor && theme.custom.primaryColor !== '#ffffff' && window.location.pathname.split("/").includes("events")) {
      // const rgbCommunityColor: any = miscUtils.hexToRgb(theme.custom.primaryColor);

      return {
        color: theme.custom.fontColor,
        backgroundColor: theme.custom.primaryColor
        // backgroundColor: rgbCommunityColor ? `rgba(${rgbCommunityColor.r}, ${rgbCommunityColor.g}, ${rgbCommunityColor.b}, .1)` : '',
      }
    }
    return {}
  }

  function getHomeLinkStyle() {
    if (theme && theme.custom && theme.custom.primaryColor !== '#ffffff' && (window.location.pathname === "/home") && !showCommunityLandingPage()) {
      // const rgbCommunityColor: any = miscUtils.hexToRgb(theme.custom.primaryColor);

      return {
        color: theme.custom.fontColor,
        backgroundColor: theme.custom.primaryColor

        // backgroundColor: rgbCommunityColor ? `rgba(${rgbCommunityColor.r}, ${rgbCommunityColor.g}, ${rgbCommunityColor.b}, .1)` : '',
      }
    }
    return {}
  }

  function getFeedLinkStyle() {
    if (theme && theme.custom && theme.custom.primaryColor && window.location.pathname === "/feed") {
      // const rgbCommunityColor: any = miscUtils.hexToRgb(theme.custom.primaryColor);

      return {
        color: theme.custom.fontColor,
        backgroundColor: theme.custom.primaryColor

        // backgroundColor: rgbCommunityColor ? `rgba(${rgbCommunityColor.r}, ${rgbCommunityColor.g}, ${rgbCommunityColor.b}, .1)` : '',
      }
    }
    return {}
  }

  function getLibraryLinkStyles(url: string) {
    if (theme && theme.custom && theme.custom.primaryColor && theme.custom.primaryColor !== '#ffffff' && window.location.pathname.split("/").includes(url)) {
      // const rgbCommunityColor: any = miscUtils.hexToRgb(theme.custom.primaryColor);

      return {
        color: theme.custom.fontColor,
        backgroundColor: theme.custom.primaryColor

        // backgroundColor: rgbCommunityColor ? `rgba(${rgbCommunityColor.r}, ${rgbCommunityColor.g}, ${rgbCommunityColor.b}, .1)` : '',
      }
    }
    return {}
  }

  function checkPostPage(channelId: number, group: string) {
    if (group) {
      selectChannel(channelId);
      setIsGroup(group.length > 0);
      switchToGroup();
      setTimeout(() => setChannelSidebarStatus(true), 2000);
    }
  }

  function checkSelectedGroupPermission() {
    if (userGroups && selectedGroup && sidebarGroups) {
      let isAdminOfSelectedGroup = false;
      sidebarGroups.data.forEach((group: any) => {
        if (
          group.group.slug === selectedGroup &&
          (group.admin || group.owner)
        ) {
          isAdminOfSelectedGroup = true;
        }
      });
      setIsAdmin(isAdminOfSelectedGroup);
    }
  }

  const MyLoader = () => {
    return (
      <ContentLoader
        height={162}
        width={280}
        speed={1}
        primaryColor="#FFF"
        secondaryColor="#ecebeb"
      >
        <rect x="0" y="0" rx="5" ry="5" width="280" height="42" />
        <rect x="0" y="60" rx="4" ry="4" width="280" height="42" />
        <rect x="0" y="120" rx="5" ry="5" width="280" height="42" />
      </ContentLoader>
    );
  };

  function openModal() {
    setToggleModal(true);
  }

  function closeModal() {
    unlockBackground();
    setToggleModal(false);
  }

  function changeGroupInviteLink() {
    if (group) {
      GroupService.getInstance()
        .changeGroupInviteLink(group.id)
        .then(() => { })
    }
  }

  function setChannelToActive(selectedChannel: any, channel: any) {
    return selectedChannel === channel.slug &&
      !(
        props.group &&
        props.group.home_page_config &&
        props.group.home_page_config.status &&
        props.group.default_channel &&
        props.group.default_channel.slug === selectedChannel &&
        window.location.pathname === "/home"
      ) &&
      !window.location.pathname.split("/").includes("library") &&
      !window.location.pathname.split("/").includes("members") &&
      !window.location.pathname.split("/").includes("courses")
      ? "channel-link active"
      : "channel-link";
  }

  const clickOnAdminPanel = () => {
    window.scrollTo({
      top: 0,
      behavior: 'auto',
    });

    if (
      props.group &&
      !props.group.active_subscription &&
      miscUtils.isModerator(props.group.user_membership)
    ) {
      setIsOpen(true);
      toast("Please contact an admin", {
        type: 'info',
        autoClose: 2000,
        position: "top-center",
        hideProgressBar: true,
        theme: "light"
      });
      return;
    }

    if(
      props.group &&
      props.group.members_count &&
      props.group.members_count < 4
    ) {
      history.push('/settings/admin-dashboard');
      return;
    }

    history.push('/settings/members');
  }

  const getDisplayedUnreadPosts = (count: number) => {
    if (count <= 9) {
      return `${count}`
    }

    return '9+'
  }

  const readChannelPosts = (channelId: any) => {
    ChannelService.getInstance()
      .readChannelPosts(channelId)
      .then(() => { })
      .catch(() => { });
  }

  const clearChannelPostCount = (channelId: any, channelIndex: any, collectionIndex?: any) => {
    if (collectionIndex || collectionIndex === 0) {
      if (channelCollections[collectionIndex].channels[channelIndex].unread_post_count > 0) {
        const channelCollectionsCopy: any = JSON.parse(JSON.stringify(channelCollections));

        channelCollectionsCopy[collectionIndex].channels[channelIndex] = {
          ...channelCollectionsCopy[collectionIndex].channels[channelIndex],
          unread_post_count: 0,
        }

        setChannelCollections([...channelCollectionsCopy]);

        readChannelPosts(channelId);
      }
    } else {
      if (unAssignedChannels[channelIndex] && unAssignedChannels[channelIndex].unread_post_count > 0) {
        const unAssignedChannelsCopy: any = JSON.parse(JSON.stringify(unAssignedChannels));

        unAssignedChannelsCopy[channelIndex] = {
          ...unAssignedChannelsCopy[channelIndex],
          unread_post_count: 0,
        }

        setUnAssignedChannels([...unAssignedChannelsCopy]);

        readChannelPosts(channelId);
      }
    }
  }

  const themeIconColor = appContext.group && appContext.group.custom_branding && appContext.group.custom_branding.fontColor
  const rawCommunityTheme = appContext.group && appContext.group.custom_branding && appContext.group.custom_branding.primaryColor
  const isCustomgroupTheme = rawCommunityTheme && rawCommunityTheme !== '#ffffff'
  const switcherElement: any = document.getElementById('communities-sidebar');
  const UpgradePlanBannerEl: any = document.getElementById('UpgradePlanBanner')

  return (
    <div
      className={`${
        (sidebarGroups && sidebarGroups.data.length > 0) || group
          ? "sidebar"
          : "sidebar new-user"
      } ${
        appContext.isSidebarEmptyRef.current || window.location.pathname === '/creategroup' || (window.location.pathname.split('/')[1] === 'settings')  ?
          'display-none' :
          ''
        }`}
        key={reloadKey}
       style={{
        left: switcherElement ? '4.5rem' : (showChannelSidebar && window.innerWidth <= 991) ? '0' : '',
         backgroundColor:isCustomgroupTheme && switcherElement ? rawCommunityTheme : '',
       }}
    >
      <div 
      //  style={isCustomgroupTheme ? { backgroundColor: communityTheme } : {}}
      className={`sidebar__wrap ${(window.location.pathname.split("/")[1] === 'settings' || window.location.pathname === '/about') ? 'sidebar-border-none' : ''}`}>
        <div className="sidebar__content">
          {loadSidebarGroup && groupChannelsLoading ? (
            <>
              {isSideBar && !window.location.pathname.split("/").includes("settings") ? (
                <div className="sidebar-content-loader">
                  <MyLoader />
                </div>
              ) : (
                <div className="sidebar-content-loader-closed">
                  <MyLoader />
                </div>
              )}
            </>
          ) : sidebarGroups || group ? (
            <div className="sidebar__content-group-list">
              {isGroup && (
                <div className="sidebar__content-channels-list">
                  <PerfectScrollbar
                    className="sidebar-scrollable-content"
                    options={{
                      wheelPropagation: false,
                    }}
                  >
                    <div className="sidebar__content-channels-list--header">
                      {((props.group &&
                        props.group.user_membership &&
                        props.group.user_membership.owner) ||
                        (props.group &&
                          props.group.user_membership &&
                          (miscUtils.isAdmin(props.group.user_membership) ||
                            miscUtils.isModerator(props.group.user_membership)
                          ))) && (
                          <button
                            className="admin-link"
                            onClick={clickOnAdminPanel}
                          >
                            Admin Panel
                          </button>
                        )}
                      {props.group && props.group.status === "open" && (
                        <div className="sidebar-channel__search-wrap">
                          <input
                            placeholder={"Search"}
                            value={postsSearchQuery}
                            onChange={e => setPostsSearchQuery(e.target.value)}
                            onKeyDown={e => {
                              if (e.key === "Enter") {
                                props.setPostsQuery(postsSearchQuery);
                              }
                            }}
                            className="channel-search"
                          />
                          <SearchIcon />
                        </div>
                      )}
                      {props.group && props.group.status !== "open" && (
                        <>
                          {props.group &&
                            miscUtils.isActiveCommunityMember(props.group.user_membership) && (
                              <div className="sidebar-channel__search-wrap">
                                <input
                                  placeholder={"Search"}
                                  value={postsSearchQuery}
                                  onChange={e =>
                                    setPostsSearchQuery(e.target.value)
                                  }
                                  onKeyDown={e => {
                                    if (e.key === "Enter") {
                                      props.setPostsQuery(postsSearchQuery);
                                    }
                                  }}
                                  className="channel-search"
                                />
                                <SearchIcon />
                              </div>
                            )}
                        </>
                      )}
                    </div>

                    <div className={`joined-channels ${UpgradePlanBannerEl ? 'joined-channels-UpgradePlanBannerSettings' : ''}`}>
                      <div className={`joined-channels-side-bar sidebar-actions ${props.group && !props.group.menu['invite']['show'] ? 'sidebar-actions-padding-bottom' : ""} `}>
                        {/* {
                          shouldShowMenuText &&
                          <h1 className="sidebar-actions-menu-text">Menu</h1>
                        } */}
                        {shouldShowHomePage && (
                          <Link
                            style={getHomeLinkStyle()}
                            className={`action ${((window.location.pathname === "/home") && !showCommunityLandingPage()) && "active-courses"}`}
                            to={
                              // showingCommuintyLandingPage() ? 
                              subdomain ?
                                `/home` :
                                `/group/${group && group.slug}/home`
                              // subdomain
                              //   ? `/`
                              //   : `/group/${group && group.slug}/`
                            }
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                behavior: 'auto',
                              });
                              closeHamburgerMenu();
                            }}
                          >
                            <div className="sidebar-icons-container">
                              <HomeIcon
                                strokeColor={
                                  themeIconColor !== null && ((window.location.pathname === "/home") && !showCommunityLandingPage())
                                    ?
                                    themeIconColor
                                    :
                                    themeIconColor === null && ((window.location.pathname === "/home") && !showCommunityLandingPage())
                                      ?
                                      '#191b1f'
                                      :
                                      undefined
                                }
                              />
                            </div>
                            Home
                          </Link>)}

                        {group && group.menu['feed']['show'] && (
                          <Link
                            style={getFeedLinkStyle()}
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                behavior: 'auto',
                              });
                              closeHamburgerMenu();
                            }}
                            className={`action ${window.location.pathname === "/feed" && "active-courses"}`}
                            to={
                              subdomain
                                ? `/feed`
                                : `/group/${props.group && props.group.slug}/feed`
                            }
                          >
                            <div className="sidebar-icons-container">
                              <FeedIcon
                                strokeColor={
                                  themeIconColor !== null && window.location.pathname === "/feed"
                                    ?
                                    themeIconColor
                                    :
                                    themeIconColor === null && window.location.pathname === "/feed"
                                      ?
                                      '#191b1f'
                                      :
                                      undefined
                                }
                              />
                            </div>
                            Feed
                          </Link>)}

                        {group && group.menu['courses']['show'] && (
                          <Link
                            style={getLibraryLinkStyles("courses")}
                            className={`action ${window.location.pathname.split("/").includes(
                              "courses"
                            ) && "active-courses"}`}
                            to={
                              subdomain
                                ? `/courses`
                                : `/group/${group && group.slug}/courses`
                            }
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                behavior: 'auto',
                              });
                              closeHamburgerMenu();
                            }}
                          >
                            <div className="sidebar-icons-container">
                              <CourseIcon
                                strokeColor={
                                  themeIconColor !== null && window.location.pathname.split("/").includes("courses")
                                    ?
                                    themeIconColor
                                    :
                                    themeIconColor === null && window.location.pathname.split("/").includes("courses")
                                      ?
                                      '#191b1f'
                                      :
                                      undefined
                                }
                              />
                            </div>
                            Courses
                          </Link>)}

                        {group && group.menu['library']['show'] && (
                          <Link
                            style={getLibraryLinkStyles("library")}
                            className={
                              `action 
                              ${window.location.pathname.split("/").includes("library") && "active-courses"}
                              `}
                            to={
                              subdomain
                                ? `/library`
                                : `/group/${group && group.slug}/library`
                            }
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                behavior: 'auto',
                              });
                              closeHamburgerMenu();
                            }}
                          >
                            <div className="sidebar-icons-container">
                              <LibraryIcon
                                strokeColor={
                                  themeIconColor !== null && window.location.pathname.split("/").includes("library")
                                    ?
                                    themeIconColor
                                    :
                                    themeIconColor === null && window.location.pathname.split("/").includes("library")
                                      ?
                                      '#191b1f'
                                      :
                                      undefined
                                }
                              />
                            </div>
                            Library
                          </Link>)}

                        {group && group.menu['events']['show'] ? (
                          <Link
                            style={getEventsLinkStyle()}
                            className={`action ${window.location.pathname.split("/").includes("events") && "active-courses"}`}
                            to={
                              subdomain
                                ? `/events`
                                : `/group/${group && group.slug}/events`
                            }
                            onClick={() => {
                              window.scrollTo({
                                top: 0,
                                behavior: 'auto',
                              });
                              closeHamburgerMenu();
                            }}
                          >
                            <div className="sidebar-icons-container">
                              <CalenderIcon
                                strokeColor={
                                  themeIconColor !== null && window.location.pathname.split("/").includes("events")
                                    ?
                                    themeIconColor
                                    :
                                    themeIconColor === null && window.location.pathname.split("/").includes("events")
                                      ?
                                      '#191b1f'
                                      :
                                      undefined
                                }
                              />
                            </div>
                            Events
                          </Link>
                        ) : <></>}

                        {
                          group &&
                          group.menu['people']['show'] &&
                          group.user_membership &&
                          miscUtils.isActiveCommunityMember(group.user_membership) && (
                            <Link
                              style={window.location.pathname === "/members" ? getPeopleLinkStyle() : {}}
                              className={`action ${window.location.pathname === "/members" ? "active-courses" : ''}`}
                              to={
                                subdomain
                                  ? `/members`
                                  : `/group/${group && group.slug}/members`
                              }
                              onClick={() => {
                                window.scrollTo({
                                  top: 0,
                                  behavior: 'auto',
                                });
                                closeHamburgerMenu();
                              }}
                            >
                              <div className="sidebar-icons-container">
                                <PeopleIcon
                                  strokeColor={
                                    themeIconColor !== null && window.location.pathname.split("/").includes("members")
                                      ?
                                      themeIconColor
                                      :
                                      themeIconColor === null && window.location.pathname.split("/").includes("members")
                                        ?
                                        '#191b1f'
                                        :
                                        undefined
                                  }
                                />
                              </div>
                              People
                            </Link>
                          )}

                        {group && group.menu['invite']['show'] && (
                          <Link
                            className={`action`}
                            to={'#'}
                            onClick={() => openModal()}
                          >
                            <div className="sidebar-icons-container">
                              <InvitePlusIcon
                                strokeColor={'#666666'}
                              />
                            </div>
                            Invite members
                          </Link>)}

                      </div>
                      {
                        groupChannels === null
                          ?
                          <></>
                          :
                          groupChannels.length === 0
                            ?
                            <></>
                            :
                            groupChannels.length > 0
                              ?
                              <div className={`joined-channels__scroll-area ${!shouldShowMenuText ? 'no-margin-top' : ''}`}
                                style={{
                                  border: (groupChannels && groupChannels.length === 0) ? 'none' : '',
                            backgroundColor: (groupChannels &&groupChannels.length === 0) ? '' : 'transparent'
                                }}
                              >
                                {!groupChannelsLoading && (
                                  channelCollections.map((collection: any, collectionIndex: any) => (
                                    <Collapse
                                    // key={reloadKey}
                                   style={{
                                      backgroundColor: 'transparent',
                                    }}
                                      accordion={null}
                                      className="header-parent"
                                      defaultActiveKey={collection.open ? "0" : null}
                                      onChange={(key: Array<any>) => setChannelCollections(channelCollections.map((channelCollection: any) => {
                                        if (channelCollection.id === collection.id) {
                                          return {
                                            ...channelCollection,
                                            open: key.length > 0,
                                          }
                                        }

                                        return channelCollection;
                                      }))}
                                      expandIcon={() => <FontAwesomeIcon icon={collection.open ? faChevronDown : faChevronUp} />}
                                    >
                                      <Collapse.Panel
                                        header={miscUtils.truncateString(collection.name, 19)}
                                        className="header-item"
                                              style={{
                                      backgroundColor: 'transparent',
                                    }}

                                      >
                                        <ul>
                                          {collection.channels.map((channel: any, channelIndex: any) => (
                                              <li
                                                key={channel.slug}
                                                onClick={() => {
                                                  if (redirectToLink(channel)) {
                                                    window.location.assign(redirectToLink(channel));
                                                    return
                                                  }
                                                  history.push(`/channel/${channel.slug}`);
                                                  clearChannelPostCount(channel.id, channelIndex, collectionIndex);
                                                  viewChannel(channel.slug);
                                                }
                                                }
                                                style={miscUtils.getChannelLinksColor(props.group, channel, selectedChannel, theme)}
                                                className={setChannelToActive(
                                                  selectedChannel,
                                                  channel
                                                )}
                                              >
                                                <div
                                                  title={channel.name}
                                                  className="gp-sidebar-channel-container"
                                                >
                                                  <div
                                                    className="gp-channel-emoji-container"
                                                  >
                                                    {
                                                      channel.emoji ?
                                                        <span
                                                          className="sidebar-emoji"
                                                          dangerouslySetInnerHTML={{
                                                            //@ts-ignore
                                                            __html: Emoji({
                                                              html: true,
                                                              set: "apple",
                                                              emoji: channel.emoji,
                                                              size: 18
                                                            })
                                                          }}
                                                        /> :
                                                        <ChannelHashTag
                                                          fill={
                                                            theme &&
                                                              theme.custom &&
                                                              !window.location.pathname.split("/").includes("library") &&
                                                              !window.location.pathname.split("/").includes("members") &&
                                                              !window.location.pathname.split("/").includes("courses") &&
                                                              selectedChannel === channel.slug ?
                                                              theme.custom.fontColor :
                                                              channel.unread_post_count ?
                                                                '#000' :
                                                                undefined
                                                          }
                                                        />
                                                    }
                                                  </div>
                                                  <p
                                                    className={`gp-sidebar-channel-name ${channel.unread_post_count ? 'gp-sidebar-channel-name--badge' : ''}`}
                                                    style={miscUtils.getChannelNamesColor(group, channel, selectedChannel, theme)}
                                                  >
                                                    {channel.name}
                                                  </p>
                                                </div>
                                                {channel.unread_post_count ? (
                                                  <div
                                                    className={`items-count-container--channel`}
                                                    style={{
                                                      backgroundColor: (theme && theme.custom) ? theme.custom.primaryColor : "",
                                                    }}
                                                  >
                                                    <p>{getDisplayedUnreadPosts(channel.unread_post_count)}</p>
                                                  </div>
                                                ) : (<></>)}
                                              </li>
                                            // </Link>
                                          ))}
                                        </ul>
                                      </Collapse.Panel>
                                    </Collapse>
                                  ))
                                )}
                                {!groupChannelsLoading && unAssignedChannels.length > 0 && (
                                  <Collapse
                                    accordion={null}
                                    className="header-parent"
                                    defaultActiveKey="0"
                                    onChange={(key: Array<any>) => setUnAssignedChannelsActive(key.length > 0)}
                                    expandIcon={() => <FontAwesomeIcon icon={unAssignedChannelsActive ? faChevronDown : faChevronUp} />}
                                             style={{
                                      backgroundColor: 'transparent',
                                    }}

                                  >
                                    <Collapse.Panel
                                      header="CHANNELS"
                                      className="header-item"
                                             style={{
                                      backgroundColor: 'transparent',
                                    }}

                                    >
                                      <ul>
                                        {unAssignedChannels.map((channel: any, channelIndex: any) => (
                                            <li
                                              key={channelIndex}
                                              onClick={() => {
                                                 if (redirectToLink(channel)) {
                                                    window.location.assign(redirectToLink(channel));
                                                    return
                                                  }
                                                  history.push(`/channel/${channel.slug}`);
                                                  clearChannelPostCount(channel.id, channelIndex);
                                                  viewChannel(channel.slug);
                                              }
                                              }
                                              style={miscUtils.getChannelLinksColor(props.group, channel, selectedChannel, theme)}
                                              className={setChannelToActive(
                                                selectedChannel,
                                                channel
                                              )}
                                            >
                                              <div
                                                title={channel.name}
                                                className="gp-sidebar-channel-container"
                                              >
                                                <div
                                                  className="gp-channel-emoji-container"
                                                >
                                                  {
                                                    channel.emoji ?
                                                      <span
                                                        className="sidebar-emoji"
                                                        dangerouslySetInnerHTML={{
                                                          //@ts-ignore
                                                          __html: Emoji({
                                                            html: true,
                                                            set: "apple",
                                                            emoji: channel.emoji,
                                                            size: 18
                                                          })
                                                        }}
                                                      /> :
                                                      <ChannelHashTag
                                                        fill={
                                                          theme &&
                                                            theme.custom &&
                                                            !window.location.pathname.split("/").includes("library") &&
                                                            !window.location.pathname.split("/").includes("members") &&
                                                            !window.location.pathname.split("/").includes("courses") &&
                                                            selectedChannel === channel.slug ?
                                                            theme.custom.fontColor :
                                                            channel.unread_post_count ?
                                                              '#000' :
                                                              undefined
                                                        }
                                                      />
                                                  }
                                                </div>
                                                <p
                                                  className={`gp-sidebar-channel-name ${channel.unread_post_count ? 'gp-sidebar-channel-name--badge' : ''}`}
                                                    style={miscUtils.getChannelNamesColor(group, channel, selectedChannel, theme)}

                                                >
                                                  {channel.name}
                                                </p>
                                              </div>
                                              {channel.unread_post_count ? (
                                                <div
                                                  className={`items-count-container--channel`}
                                                  style={{
                                                    backgroundColor: (theme && theme.custom && theme.custom.primaryColor !== '#ffffff') ? theme.custom.primaryColor : "",
                                                  }}
                                                >
                                                  <p>{getDisplayedUnreadPosts(channel.unread_post_count)}</p>
                                                </div>
                                              ) : (<></>)}
                                            </li>
                                          // </Link>
                                        ))}
                                      </ul>
                                    </Collapse.Panel>
                                  </Collapse>
                                )}
                                {groupChannelsLoading && (
                                  <ContentLoader
                                    height={220}
                                    width={200}
                                    speed={1}
                                    primaryColor="#dbdbdb"
                                    secondaryColor="#ecebeb"
                                  >
                                    <rect
                                      x="0"
                                      y="0"
                                      rx="3"
                                      ry="3"
                                      width="200"
                                      height="20"
                                    />
                                    <rect
                                      x="0"
                                      y="35"
                                      rx="3"
                                      ry="3"
                                      width="200"
                                      height="34"
                                    />
                                    <rect
                                      x="0"
                                      y="100"
                                      rx="3"
                                      ry="3"
                                      width="70"
                                      height="16"
                                    />
                                    <rect
                                      x="10"
                                      y="130"
                                      rx="3"
                                      ry="3"
                                      width="120"
                                      height="16"
                                    />
                                    <rect
                                      x="10"
                                      y="160"
                                      rx="3"
                                      ry="3"
                                      width="120"
                                      height="16"
                                    />
                                    <rect
                                      x="10"
                                      y="190"
                                      rx="3"
                                      ry="3"
                                      width="120"
                                      height="16"
                                    />
                                  </ContentLoader>
                                )}
                              </div>
                              :
                              <></>
                      }

                      {
                        group && group.external_links && group.external_links && group.external_links.length > 0 &&
                          <div className={`joined-channels__scroll-area links${
                            !shouldShowMenuText &&
                            groupChannels &&
                            groupChannels.length === 0 ?
                            ' no-margin-top--links' : ''
                          }`}>
                          <Collapse
                            accordion={null}
                            className="header-parent"
                            defaultActiveKey="0"
                            onChange={(key: Array<any>) => setlinksActive(key.length > 0)}
                            expandIcon={() => <FontAwesomeIcon icon={linksActive ? faChevronDown : faChevronUp} />}
                                             style={{
                                      backgroundColor: 'transparent',
                                    }}

                          >
                            <Collapse.Panel
                              header="Links"
                              className="header-item"
                                             style={{
                                      backgroundColor: 'transparent',
                                    }}

                            >
                              <ul>
                                {group.external_links.map((channel: any, index: any) => (
                                  <a
                                    href={channel.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    key={index}
                                  >
                                    <li
                                      key={index}
                                    >
                                      <div
                                        title={channel.label}
                                        className="gp-sidebar-channel-container"
                                      >
                                        <div
                                          className="gp-channel-emoji-container"
                                        >
                                          <GlobeIcon />
                                        </div>
                                        <p className={`gp-sidebar-channel-name`}>
                                          {channel.label}
                                        </p>
                                      </div>

                                    </li>
                                  </a>
                                ))}
                              </ul>
                            </Collapse.Panel>
                          </Collapse>
                        </div>
                      }
                    </div>
                  </PerfectScrollbar>
                </div>
              )}
            </div>
          ) : (
            <React.Fragment>
              {areGroupsEmpty && (
                <button
                  className={"btn btn-create-group"}
                  onClick={() => {
                    props.createGroup();
                  }}
                >
                  <PlusWithCircle />
                  <span>Create community</span>
                </button>
              )}
            </React.Fragment>
          )}
        </div>
      </div>
      {isModalOpen && (
        <ReactModal
          isOpen={isModalOpen}
          className='invite-member-details-popup'
          style={{
            content: {
              width: "500px",
              maxWidth: "calc(100vw - 10px)",
              minHeight: "auto",
              borderRadius: "0.5rem",
            },
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 99999,
            }
          }}
        >
          <div className="invite--group__header-card">

            <ShareGroup
              theme={theme}
              usersGroups={userGroups}
              groupData={group}
              generateNewLink={true}
              changeLink={changeGroupInviteLink}
              closeModal={closeModal}
            />
          </div>
        </ReactModal>
      )}
      <>
        <AppModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          title="Community Subscription Expired"
          message="Please contact an admin to renew the subscription"
          buttonText="OK"
        />
      </>
    </div>
  );
};

const mapStateToProps = (state: any, ownProps: ISidebarComponentProps) => {
  const global = Map(state.get("global", {})).toJS() as any;
  const groups = Map(state.get("group", {})).toJS() as any;
  const uid: string = state.getIn(["authorize", "uid"]) as string;
  return {
    uid,
    global,
    groups
  };
};

const mapDispatchToProps = (
  dispatch: any,
  ownProps: ISidebarComponentProps
) => {
  return {
    createGroup: () => {
      dispatch(push("/creategroup"));
    },
    goToChannel: (
      groupSlug: string,
      channelId: number,
      isSubdomain: boolean
    ) => {
      dispatch(
        push(
          isSubdomain
            ? `/channel/${channelId}`
            : `/channel/${groupSlug}/${channelId}`
        )
      );
    },
    setSidebarVisibility: (status: boolean) =>
      dispatch(globalActions.setSidebarVisibility(status)),
    setPostsQuery: (query: string) =>
      dispatch(globalActions.setPostsQuery(query)),
    setChannelSidebarStatus: (status: boolean) =>
      dispatch(globalActions.setChannelSidebar(status)),
    closeHamburgerMenu: () => dispatch(globalActions.closeHamburgerMenu()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SidebarComponent as any) as any
) as any;
